import {
  DATE_PAD_CHARACTER,
  DATE_PAD_LENGTH,
  DATE_SEPARATOR,
  DAYS_IN_WEEK,
  EMPTY_CALENDAR_DAY,
  LAST_DAY_OF_MONTH,
  MONDAY_NUMBER,
  MONTH_NAMES,
  MONTH_NUMBER_OFFSET,
  NEXT_MONTH_OFFSET,
  SUNDAY_INDEX
} from './my-working-report.constants';
import { CalendarDayQuery, CalendarMonth } from './my-working-report.types';

export function buildCalendarMonths(fromValue: string, toValue: string): CalendarMonth[] {
  if (!fromValue || !toValue) {
    return [];
  }
  const fromDate = new Date(fromValue);
  const toDate = new Date(toValue);
  if (fromDate > toDate) {
    return [];
  }
  return monthsBetween(fromDate, toDate);
}

export function isWorkingCalendarDay(query: CalendarDayQuery, workDays: string[]): boolean {
  if (query.day === EMPTY_CALENDAR_DAY) {
    return false;
  }
  const monthNumber = MONTH_NAMES.indexOf(query.monthName) + MONTH_NUMBER_OFFSET;
  const month = String(monthNumber).padStart(DATE_PAD_LENGTH, DATE_PAD_CHARACTER);
  const day = String(query.day).padStart(DATE_PAD_LENGTH, DATE_PAD_CHARACTER);
  const date = String(query.year) + DATE_SEPARATOR + month + DATE_SEPARATOR + day;
  return workDays.includes(date);
}

function monthsBetween(fromDate: Date, toDate: Date): CalendarMonth[] {
  const months: CalendarMonth[] = [];
  const current = new Date(fromDate.getFullYear(), fromDate.getMonth(), MONDAY_NUMBER);
  const endYear = toDate.getFullYear();
  const endMonth = toDate.getMonth();
  while (isMonthWithinRange(current, endYear, endMonth)) {
    months.push(createCalendarMonth(current.getFullYear(), current.getMonth()));
    current.setMonth(current.getMonth() + NEXT_MONTH_OFFSET);
  }
  return months;
}

function isMonthWithinRange(current: Date, endYear: number, endMonth: number): boolean {
  return current.getFullYear() < endYear
    || (current.getFullYear() === endYear && current.getMonth() <= endMonth);
}

function createCalendarMonth(year: number, month: number): CalendarMonth {
  const lastDay = new Date(year, month + NEXT_MONTH_OFFSET, LAST_DAY_OF_MONTH).getDate();
  const days = calendarDays(lastDay, calendarPadding(year, month));
  return {month: MONTH_NAMES[month], year: year, days: days};
}

function calendarPadding(year: number, month: number): number {
  const weekday = new Date(year, month, MONDAY_NUMBER).getDay();
  const mondayBasedWeekday = weekday === SUNDAY_INDEX ? DAYS_IN_WEEK : weekday;
  return mondayBasedWeekday - MONDAY_NUMBER;
}

function calendarDays(lastDay: number, padding: number): number[] {
  const days: number[] = [];
  for (let index = EMPTY_CALENDAR_DAY; index < padding; index++) {
    days.push(EMPTY_CALENDAR_DAY);
  }
  for (let day = MONDAY_NUMBER; day <= lastDay; day++) {
    days.push(day);
  }
  return days;
}



// WEBPACK FOOTER //
// C:/work/internal-frontend/src/app/content-page/my-working-report/my-working-report-calendar.ts